import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
`;

export const List = styled.div`
  display: flex;
  overflow: hidden;
`;

export const Button = styled.button`
  position: absolute;
  z-index: 1;
  top: 50%;
  transform: translateY(-50%);
  left: ${({ position }) => (position === 'left' ? '2px' : 'auto')};
  right: ${({ position }) => (position === 'right' ? '2px' : 'auto')};
  height: 48px;
  width: 48px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 0 2px 4px rgba(0, 0, 0, 0.1);
  border: none;
  font-size: 14px;
  line-height: 100%;
  color: #000;
  cursor: pointer;
`;
